import React, { useContext, useEffect } from 'react';
import LeadContext from '../../../Portfolio/subrouters/Buyer/providers/Lead/Lead.context';
import MessagingRouter from '../../Messaging.router';
import MessagingProvider from '../../providers/Messaging';
import { useLockScrollOnReroute } from 'hooks/useLockScrollOnReroute';
import HelmetWrapper from 'components/HelmetWrapper';
import { Navigate, useParams } from 'react-router-dom';

import './MessageBuyerWrapper.styles.scss';

const MessagingBuyerWrapper: React.FC = () => {
  const {
    dealRoom,
    listing,
    sessionId,
    unreadMessagesCount,
    updateUnreadMessagesCount,
  } = useContext(LeadContext);

  const { sessionId: paramsSessionId } = useParams();

  const { _id: listingId, listingEnquiryId } = listing || {};
  const { portfolioName } = dealRoom || {};

  useLockScrollOnReroute();

  useEffect(() => {
    if (unreadMessagesCount) updateUnreadMessagesCount(0);
  }, [unreadMessagesCount, updateUnreadMessagesCount]);

  if (!paramsSessionId && sessionId) return <Navigate to={sessionId} replace />;

  return (
    <MessagingProvider
      messagingPortfolioProps={{ listingId, listingEnquiryId }}
    >
      <HelmetWrapper title={`Chat - ${portfolioName}`} />
      <MessagingRouter className="buyer-messaging-router" />
    </MessagingProvider>
  );
};

export default MessagingBuyerWrapper;
